<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- Page header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">สมัครบัตรสมาชิก (พนักงาน)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        สมัครแทนลูกค้า แล้วส่งลิงก์ชำระเงินทาง LINE หรือแสดง QR ให้ลูกค้าสแกน
      </p>
    </div>
    <button *ngIf="result" type="button" (click)="resetForm()"
      class="px-5 py-3 h-[46px] bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
      <span class="material-icons text-[18px]">add</span>
      สมัครรายการใหม่
    </button>
  </div>

  <!-- Success result -->
  <div *ngIf="result"
    class="animate-fade-in mb-6 bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-emerald-200/70 dark:border-emerald-800/50 overflow-hidden">
    <div class="px-6 py-5 border-b border-emerald-100 dark:border-emerald-900/40 bg-emerald-50/50 dark:bg-emerald-900/15 flex items-center gap-3">
      <div class="w-10 h-10 rounded-xl bg-emerald-500 text-white flex items-center justify-center shrink-0">
        <span class="material-icons text-[20px]">check_circle</span>
      </div>
      <div>
        <h2 class="text-lg font-black text-slate-800 dark:text-slate-100">สร้างคำขอชำระเงินสำเร็จ</h2>
        <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ result.message }}</p>
      </div>
    </div>

    <div class="p-6 md:p-8 grid grid-cols-1 md:grid-cols-[220px_1fr] gap-6 items-start">
      <div class="flex justify-center">
        <div class="bg-white rounded-2xl p-3 border border-slate-100 dark:border-slate-700 shadow-sm">
          <img [src]="qrUrl" alt="QR ชำระเงิน" class="w-[200px] h-[200px]" />
        </div>
      </div>

      <div class="space-y-4 min-w-0">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div class="rounded-2xl bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 px-4 py-3">
            <div class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-1">เลขที่คำขอ</div>
            <div class="font-mono font-bold text-slate-800 dark:text-slate-100">{{ result.requestNo || '—' }}</div>
          </div>
          <div class="rounded-2xl bg-amber-50 dark:bg-amber-900/20 border border-amber-100 dark:border-amber-900/40 px-4 py-3">
            <div class="text-[11px] font-bold text-amber-700/70 dark:text-amber-400/80 uppercase tracking-wider mb-1">ยอดชำระ</div>
            <div class="font-black text-amber-700 dark:text-amber-400 tabular-nums">{{ result.total | number:'1.2-2' }} บาท</div>
          </div>
        </div>

        <div class="flex flex-wrap gap-2 text-[11px] font-bold">
          <span *ngIf="result.lineSent"
            class="px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400 border border-emerald-200/60">ส่ง LINE แล้ว</span>
          <span *ngIf="linkLine && !result.lineSent"
            class="px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 border border-amber-200/60">ส่ง LINE ไม่สำเร็จ — ใช้ QR/ลิงก์แทน</span>
          <span *ngIf="result.temporaryUser"
            class="px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 border border-slate-200/60">ผู้ใช้ชั่วคราว (ยังไม่เชื่อม LINE)</span>
        </div>

        <div class="flex flex-col sm:flex-row gap-3">
          <button type="button" (click)="openPaymentUrl()"
            class="px-6 py-3 h-[48px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-lg shadow-amber-200/40 dark:shadow-none flex items-center justify-center gap-2 cursor-pointer transition-all border-none">
            <span class="material-icons text-[20px]">open_in_new</span>
            เปิดลิงก์ชำระเงิน
          </button>
          <button type="button" (click)="copyPaymentUrl()"
            class="px-6 py-3 h-[48px] bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 font-bold rounded-xl border border-slate-200 dark:border-slate-700 hover:border-amber-300 flex items-center justify-center gap-2 cursor-pointer transition-all">
            <span class="material-icons text-[20px]">{{ copied ? 'check' : 'content_copy' }}</span>
            {{ copied ? 'คัดลอกแล้ว' : 'คัดลอกลิงก์' }}
          </button>
        </div>

        <p class="text-[11px] text-slate-400 break-all font-mono leading-relaxed">{{ result.paymentUrl }}</p>
      </div>
    </div>
  </div>

  <!-- Registration form -->
  <div *ngIf="!result"
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">

    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">badge</span>ข้อมูลการสมัคร
      </h3>
      <span *ngIf="siteState.selectedSite()?.name"
        class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
        <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
      </span>
    </div>

    <div class="p-6 md:p-8 space-y-8">
      <!-- Section 1: Channel -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">1</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">ช่องทางลูกค้า</h4>
        </div>

        <div class="inline-flex rounded-2xl bg-slate-100 dark:bg-slate-900 p-1 border border-slate-100 dark:border-slate-700">
          <button type="button" (click)="onLinkLineChange(true)"
            class="px-4 py-2.5 rounded-xl text-xs font-bold transition-all cursor-pointer border-none"
            [ngClass]="linkLine ? 'bg-amber-400 text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-200'">
            เชื่อม LINE OA
          </button>
          <button type="button" (click)="onLinkLineChange(false)"
            class="px-4 py-2.5 rounded-xl text-xs font-bold transition-all cursor-pointer border-none"
            [ngClass]="!linkLine ? 'bg-amber-400 text-slate-900 shadow-sm' : 'bg-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-200'">
            ไม่เชื่อม LINE
          </button>
        </div>

        <div *ngIf="linkLine" class="relative mt-4 max-w-2xl">
          <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
            ผู้ใช้ LINE OA <span class="text-rose-500">*</span>
          </label>
          <div class="relative">
            <span class="absolute left-4 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">search</span>
            <input type="text" [(ngModel)]="searchLineText" (ngModelChange)="onLineSearchChange()"
              (focus)="onInputFocus('line')" (click)="onInputFocus('line'); $event.stopPropagation()"
              (blur)="closeDropdowns()" placeholder="ค้นหาชื่อ หรือเบอร์โทร..."
              class="w-full h-[48px] pl-11 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 outline-none transition-all placeholder:font-normal">
            <span class="material-icons text-slate-400 text-sm absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
              [class.rotate-180]="openDropdown==='line'">expand_more</span>
          </div>
          <div *ngIf="openDropdown === 'line'" (mousedown)="$event.preventDefault()"
            class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-56 overflow-y-auto custom-scrollbar">
            <div *ngIf="isSearchingLine" class="px-4 py-3 text-sm text-slate-400 text-center font-bold">กำลังค้นหา...</div>
            <div *ngIf="!isSearchingLine && lineOptions.length === 0"
              class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบผู้ใช้ LINE</div>
            <button *ngFor="let user of lineOptions" type="button" (click)="selectLineUser(user)"
              class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer transition-all text-slate-700 dark:text-slate-300 border-none bg-transparent">
              <div>{{ user.fullName || user.name }}</div>
              <div class="text-[11px] font-medium text-slate-400">{{ user.phone || 'ไม่มีเบอร์' }}</div>
            </button>
          </div>
        </div>
      </section>

      <!-- Section 2: Customer -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">2</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">ข้อมูลลูกค้า</h4>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div>
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
              ชื่อลูกค้า <span class="text-rose-500">*</span>
            </label>
            <div class="relative flex items-center h-[48px] bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200">
              <span class="absolute left-4 material-icons text-slate-400 text-[18px]">person</span>
              <input type="text" [(ngModel)]="name" maxlength="120" placeholder="ชื่อ-นามสกุล"
                class="w-full h-full pl-11 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
              เบอร์โทร <span class="text-rose-500">*</span>
            </label>
            <div class="relative flex items-center h-[48px] bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200">
              <span class="absolute left-4 material-icons text-slate-400 text-[18px]">phone</span>
              <input type="tel" inputmode="tel" [(ngModel)]="phone" maxlength="20" placeholder="08xxxxxxxx"
                class="w-full h-full pl-11 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none">
            </div>
          </div>
        </div>
      </section>

      <!-- Section 3: Package -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">3</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">แพ็คเกจ / วันเริ่ม</h4>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div class="relative">
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
              ประเภทรถ <span class="text-rose-500">*</span>
            </label>
            <div class="relative">
              <input type="text" [(ngModel)]="searchVehicleTypeText" placeholder="เลือกหรือพิมพ์เพื่อค้นหา..."
                (focus)="onInputFocus('vehicleType')" (click)="onInputFocus('vehicleType'); $event.stopPropagation()"
                (blur)="closeDropdowns()"
                class="w-full h-[48px] pl-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-2 focus:ring-amber-200 outline-none">
              <span class="material-icons text-slate-400 text-sm absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
                [class.rotate-180]="openDropdown==='vehicleType'">expand_more</span>
            </div>
            <div *ngIf="openDropdown === 'vehicleType'" (mousedown)="$event.preventDefault()"
              class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar">
              <div *ngIf="filteredVehicleTypes.length === 0" class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบข้อมูล</div>
              <button *ngFor="let item of filteredVehicleTypes" type="button" (click)="selectVehicleType(item)"
                class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer text-slate-700 dark:text-slate-300 border-none bg-transparent">
                {{ item.typeName }}
              </button>
            </div>
          </div>

          <div class="relative">
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
              แพ็คเกจสมาชิก <span class="text-rose-500">*</span>
            </label>
            <div class="relative">
              <input type="text" [(ngModel)]="searchFeeText" placeholder="เลือกแพ็คเกจ..."
                (focus)="onInputFocus('fee')" (click)="onInputFocus('fee'); $event.stopPropagation()"
                (blur)="closeDropdowns()"
                class="w-full h-[48px] pl-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-2 focus:ring-amber-200 outline-none">
              <span class="material-icons text-slate-400 text-sm absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
                [class.rotate-180]="openDropdown==='fee'">expand_more</span>
            </div>
            <div *ngIf="openDropdown === 'fee'" (mousedown)="$event.preventDefault()"
              class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar">
              <div *ngIf="filteredFees.length === 0" class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบแพ็คเกจ</div>
              <button *ngFor="let item of filteredFees" type="button" (click)="selectFee(item)"
                class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer text-slate-700 dark:text-slate-300 border-none bg-transparent">
                {{ item.feeName }} ({{ item.amount | number }} บาท)
              </button>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">
              วันเริ่มสมาชิก <span class="text-rose-500">*</span>
            </label>
            <div class="h-[48px] px-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl flex items-center focus-within:ring-2 focus-within:ring-amber-200">
              <mat-form-field class="custom-mat-datepicker-input w-full">
                <input matInput [matDatepicker]="startPicker" [(ngModel)]="memberStart">
                <mat-datepicker-toggle matIconSuffix [for]="startPicker" class="text-amber-500"></mat-datepicker-toggle>
                <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
      </section>

      <!-- Section 4: Vehicles -->
      <section>
        <div class="flex items-center justify-between gap-3 mb-4">
          <div class="flex items-center gap-2">
            <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">4</span>
            <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">
              ทะเบียนรถ <span class="text-rose-500">*</span>
            </h4>
          </div>
          <button type="button" (click)="addVehicle()"
            class="text-xs font-bold text-amber-600 hover:text-amber-500 flex items-center gap-1 cursor-pointer bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 dark:hover:bg-amber-900/30 px-3 py-1.5 rounded-full border-none transition-all">
            <span class="material-icons text-[16px]">add</span>เพิ่มทะเบียน
          </button>
        </div>

        <div class="space-y-3">
          <div *ngFor="let vehicle of vehicles; let i = index"
            class="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-3 p-3 rounded-2xl bg-slate-50/80 dark:bg-slate-900/40 border border-slate-100 dark:border-slate-700">
            <div>
              <label class="block text-[11px] font-bold text-slate-400 mb-1.5">ทะเบียน <span class="text-rose-500">*</span></label>
              <input type="text" [(ngModel)]="vehicle.license" maxlength="20" placeholder="เช่น กข1234"
                class="w-full h-[46px] px-4 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-bold uppercase outline-none focus:ring-2 focus:ring-amber-200">
            </div>
            <div class="relative">
              <label class="block text-[11px] font-bold text-slate-400 mb-1.5">จังหวัด <span class="text-rose-500">*</span></label>
              <div class="relative">
                <input type="text" [(ngModel)]="vehicle.searchProvinceText" placeholder="เลือกหรือพิมพ์ค้นหาจังหวัด..."
                  (focus)="onProvinceFocus(i)" (click)="onProvinceFocus(i); $event.stopPropagation()"
                  (blur)="closeDropdowns()"
                  class="w-full h-[46px] pl-4 pr-10 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200">
                <span class="material-icons text-slate-400 text-sm absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
                  [class.rotate-180]="openDropdown === 'province-' + i">expand_more</span>
              </div>
              <div *ngIf="openDropdown === 'province-' + i" (mousedown)="$event.preventDefault()"
                class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar">
                <div *ngIf="filteredProvinces(vehicle).length === 0"
                  class="px-4 py-3 text-sm text-slate-400 text-center font-bold">ไม่พบจังหวัด</div>
                <button *ngFor="let item of filteredProvinces(vehicle)" type="button" (click)="selectProvince(i, item)"
                  class="w-full text-left px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 cursor-pointer text-slate-700 dark:text-slate-300 border-none bg-transparent">
                  {{ item.name }}
                </button>
              </div>
            </div>
            <div class="flex items-end">
              <button type="button" (click)="removeVehicle(i)" title="ลบทะเบียน"
                class="h-[46px] w-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-400 hover:text-rose-500 hover:border-rose-200 cursor-pointer flex items-center justify-center transition-all">
                <span class="material-icons text-[18px]">close</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- Section 5: Extra -->
      <section>
        <div class="flex items-center gap-2 mb-4">
          <span class="w-6 h-6 rounded-full bg-amber-400 text-slate-900 text-[11px] font-black flex items-center justify-center">5</span>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-200">ส่วนลด / หมายเหตุ</h4>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div>
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">โค้ดส่วนลด</label>
            <input type="text" [(ngModel)]="discountCode" maxlength="40" placeholder="ถ้ามี"
              class="w-full h-[48px] px-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200">
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-500 dark:text-slate-400 mb-2">หมายเหตุ</label>
            <input type="text" [(ngModel)]="remark" maxlength="200" placeholder="หมายเหตุภายใน"
              class="w-full h-[48px] px-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200">
          </div>
        </div>
      </section>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-900/40 flex justify-end">
      <button type="button" (click)="askSubmit()" [disabled]="!canCreate"
        class="px-8 h-[48px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-lg shadow-amber-200/40 dark:shadow-none flex items-center gap-2 cursor-pointer transition-all disabled:opacity-50 disabled:cursor-not-allowed border-none">
        <span class="material-icons text-[20px]">how_to_reg</span>
        สมัครบัตรสมาชิก
      </button>
    </div>
  </div>
</div>

<app-pss-confirm-modal
  *ngIf="showConfirm"
  title="ยืนยันสมัครบัตรสมาชิก?"
  [message]="linkLine ? 'สร้างคำขอชำระเงินและส่งลิงก์ทาง LINE ให้' : 'สร้างคำขอชำระเงินและแสดง QR ให้ลูกค้า'"
  [highlight]="name"
  messageSuffix=""
  confirmLabel="ยืนยันสมัคร"
  cancelLabel="ยกเลิก"
  icon="how_to_reg"
  variant="warning"
  [showIrreversibleNote]="false"
  (confirm)="confirmSubmit()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
